import { useState } from 'react';
import iconLogo from '../../assets/icon-logo.png';
import SubscriptionModal from './Modals/subscription-modal';
import { Elements } from '@stripe/react-stripe-js';
import { Link } from 'react-router-dom';

export default function SidebarNav({ logout, stripePromise, user, openSubscriptionModal, setOpenSubscriptionModal }) {  
  const [isDropdownOpen, setIsDropdownOpen] = useState(true);

  const openModal = () => {
    setOpenSubscriptionModal(true);
    setIsDropdownOpen(false);
  };

  const closeModal = () => {
    setOpenSubscriptionModal(false);
    setIsDropdownOpen(true);
  };

  return (
    <>
      <div className="navbar bg-white">
        <div className="navbar-start">
          <div className="dropdown">
            <div tabIndex={0} role="button" className="btn btn-ghost btn-circle">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
            </div>
            {isDropdownOpen && (
              <ul tabIndex={0} className="menu menu-md dropdown-content m-6 z-[1] shadow-2xl p-6 w-52 bg-white">
                <li><Link to="/">Generate</Link></li>
                <li><Link to="/generations">History</Link></li>
                <li><a onClick={openModal}>Subscription</a></li>
                <li><a onClick={logout}>Sign Out</a></li>
              </ul>
            )}
          </div>
        </div>
        <div className="navbar-right flex justify-start">
  <img src={iconLogo} alt="CopyBuddy.io Logo" className="w-[60px] -ml-5" />
</div>
      </div>
      {openSubscriptionModal &&
        <Elements stripe={stripePromise}>
          <SubscriptionModal isOpen={openSubscriptionModal} onRequestClose={closeModal} user={user} />
        </Elements>
      }
    </>
  )
}